var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("select-field", {
    attrs: {
      title: _vm.$t("pages.incomes.group_by"),
      id: _vm.id,
      form: _vm.form,
      name: _vm.name,
      options: _vm.options,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }